__turbopack_context__.v({
  "appItem": "FormattedMessage-module__LHHVlW__appItem",
  "chipSlideIn": "FormattedMessage-module__LHHVlW__chipSlideIn",
  "clearButton": "FormattedMessage-module__LHHVlW__clearButton",
  "emptyState": "FormattedMessage-module__LHHVlW__emptyState",
  "fadeIn": "FormattedMessage-module__LHHVlW__fadeIn",
  "filtersRow": "FormattedMessage-module__LHHVlW__filtersRow",
  "formattedMessage": "FormattedMessage-module__LHHVlW__formattedMessage",
  "formattedMessage__icon": "FormattedMessage-module__LHHVlW__formattedMessage__icon",
  "formattedMessage__iconActive": "FormattedMessage-module__LHHVlW__formattedMessage__iconActive",
  "formattedMessage__loading": "FormattedMessage-module__LHHVlW__formattedMessage__loading",
  "formattedMessage__md": "FormattedMessage-module__LHHVlW__formattedMessage__md",
  "keywordChip": "FormattedMessage-module__LHHVlW__keywordChip",
  "keywordChipRemove": "FormattedMessage-module__LHHVlW__keywordChipRemove",
  "keywordChipsContainer": "FormattedMessage-module__LHHVlW__keywordChipsContainer",
  "keywordInput": "FormattedMessage-module__LHHVlW__keywordInput",
  "keywordSearchSection": "FormattedMessage-module__LHHVlW__keywordSearchSection",
  "keywordSearchTip": "FormattedMessage-module__LHHVlW__keywordSearchTip",
  "loadingOverlay": "FormattedMessage-module__LHHVlW__loadingOverlay",
  "questionnaireItem": "FormattedMessage-module__LHHVlW__questionnaireItem",
  "questionnaireItemActive": "FormattedMessage-module__LHHVlW__questionnaireItemActive",
  "refineSearchContainer": "FormattedMessage-module__LHHVlW__refineSearchContainer",
  "responseText": "FormattedMessage-module__LHHVlW__responseText",
  "resultsCount": "FormattedMessage-module__LHHVlW__resultsCount",
  "searchButton": "FormattedMessage-module__LHHVlW__searchButton",
  "searchResultCard": "FormattedMessage-module__LHHVlW__searchResultCard",
  "searchResultsContainer": "FormattedMessage-module__LHHVlW__searchResultsContainer",
  "searchResultsSection": "FormattedMessage-module__LHHVlW__searchResultsSection",
  "sourceButton": "FormattedMessage-module__LHHVlW__sourceButton",
  "sourceButtonWithText": "FormattedMessage-module__LHHVlW__sourceButtonWithText",
  "sourceLink": "FormattedMessage-module__LHHVlW__sourceLink",
  "sourcesContainer": "FormattedMessage-module__LHHVlW__sourcesContainer",
  "sourcesToggleButton": "FormattedMessage-module__LHHVlW__sourcesToggleButton",
  "spin": "FormattedMessage-module__LHHVlW__spin",
  "spinner": "FormattedMessage-module__LHHVlW__spinner",
});
